__turbopack_context__.v({
  "link": "styles-module-scss-module__yABbqa__link",
  "list": "styles-module-scss-module__yABbqa__list",
  "root": "styles-module-scss-module__yABbqa__root",
  "triggers": "styles-module-scss-module__yABbqa__triggers",
});
